<template>
  <div id="similar-carousel">
    <div :id="`similar-swiper-${carouselId}`" class="swiper-container">
      <div class="swiper-wrapper">
        <slot />
      </div>
    </div>
    <div :id="`similar-carousel-prev-${carouselId}`" class="swiper-button-prev similar unset">
      <ArrowCarouselPrev />
    </div>
    <div :id="`similar-carousel-next-${carouselId}`" class="swiper-button-next similar">
      <ArrowCarouselNext />
    </div>
  </div>
</template>
<script>
import Swiper, { Navigation } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import ArrowCarouselNext from '@/components/svg/ArrowCarouselNext.vue';
import ArrowCarouselPrev from '@/components/svg/ArrowCarouselPrev.vue';
Swiper.use(Navigation);
export default {
  name: 'SimilarCarousel',
  components: {
    ArrowCarouselNext,
    ArrowCarouselPrev
  },
  props: {
    carouselId: {
      type: String,
      required: false,
      default: () => Date.now().toString()
    }
  },

  data() {
    return {
      swiperConfig: {
        grabCursor: true,
        freeMode: {
          enabled: true,
          sticky: true,
          momentum: true,
          momentumBounce: 2
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            slidesOffsetBefore: 20,
            spaceBetween: 15,
            slidesOffsetAfter: 20
          },
          640: {
            slidesPerView: 2.8,
            slidesOffsetBefore: 80,
            slidesOffsetAfter: 20,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 2.5,
            slidesOffsetBefore: 80,
            slidesOffsetAfter: 20,
            spaceBetween: 20
          },
          1600: {
            slidesPerView: 3.8,
            slidesOffsetBefore: 90,
            slidesOffsetAfter: 20,
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: `#similar-carousel-next-${this.carouselId}`,
          prevEl: `#similar-carousel-prev-${this.carouselId}`
        }
      }
    };
  },

  mounted() {
    new Swiper(`#similar-swiper-${this.carouselId}`, this.swiperConfig);
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
div#similar-carousel {
  position: relative;
}
.swiper-button-next:after {
  content: '' !important;
}
.swiper-button-prev:after {
  content: '' !important;
}
.swiper-button-next,
.swiper-button-prev {
  border-radius: 100%;
  background-color: $c_white;
  width: 30px;
  height: 30px;
  transition: background-color 0.3s ease;
  @include media-breakpoint-up(xl) {
    &:hover {
      opacity: 1 !important;
      background-color: $c_base;
      svg {
        fill: $c_white;
      }
    }
  }
  svg {
    transition: fill 0.3s ease;
    fill: black;
    width: 15px;
    height: 15px;
  }
}
.swiper-button-next.similar {
  right: 20px;
  top: -15px;
  &.swiper-button-disabled {
    // display: none;
    opacity: 0.5;
    svg {
      filter: opacity(0.7);
    }
  }
}
.swiper-button-prev.similar {
  &.unset {
    left: unset !important;
  }
  right: 60px;
  top: -15px;
  &.swiper-button-disabled {
    // display: none;
    opacity: 0.5;
    svg {
      filter: opacity(0.7);
    }
  }
}
@import '@/assets/sass/components/_show-card.scss';
</style>
